import alt from "../alt";

class CouponActions {
  constructor() {
    this.generateActions("reset", "checkFailed");
  }

  checkCouponCode(code, order) {
    return { code, order };
  }
}

export default alt.createActions(CouponActions);



// WEBPACK FOOTER //
// ./src/app/actions/CouponActions.js